module.exports = __webpack_public_path__ + "static/media/3_col_11.bf396d2c.jpg";